import { ApplicationProgressIndicator } from '@mp';
import React from 'react';
import { useIsApplicationVideoHeader } from './useIsApplicationVideoHeader';

const ApplicationHeaderProgress = (): React.ReactElement | null => {
  const isApplicationVideoHeader = useIsApplicationVideoHeader();

  if (!isApplicationVideoHeader) {
    return null;
  }

  return <ApplicationProgressIndicator />;
};

export default ApplicationHeaderProgress;
